export default __webpack_public_path__ + "assets/observatories-2.f5a70e7d.jpg";